import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replacePara'
})
export class ReplaceParaPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/§ /g, "\n").replace(/§/g, "\n").trim();
  }

}
